var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#FF3A12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1361_5278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3224 11.7L30.3148 11.703L10.2875 19.9874C10.1186 20.0566 9.96953 20.1666 9.85356 20.3076C9.73759 20.4485 9.65836 20.6161 9.62297 20.7951C9.58391 20.9827 9.59209 21.177 9.64677 21.3605C9.70144 21.5441 9.8009 21.7112 9.9362 21.8468L13.6913 25.6019C13.8765 25.787 14.1205 25.9017 14.3812 25.9262C14.6419 25.9507 14.903 25.8835 15.1195 25.7362L24.2677 19.4431C24.3038 19.4185 24.3473 19.4073 24.3908 19.4114C24.4343 19.4155 24.475 19.4346 24.5059 19.4655C24.5367 19.4964 24.5559 19.5371 24.56 19.5805C24.564 19.624 24.5528 19.6676 24.5282 19.7036L18.2355 28.8515C18.0881 29.0678 18.0208 29.3288 18.0451 29.5894C18.0695 29.8501 18.1839 30.0941 18.3688 30.2794L22.1245 34.0352C22.2538 34.1646 22.4131 34.2599 22.5883 34.3125C22.7635 34.3652 22.949 34.3735 23.1282 34.3368C23.3443 34.2932 23.5428 34.1869 23.6989 34.0312C23.8072 33.9227 23.8928 33.7937 23.9505 33.6517L32.2681 13.6582L32.2714 13.6489C32.38 13.3765 32.4064 13.0782 32.3473 12.7909C32.2882 12.5036 32.1462 12.24 31.9388 12.0326C31.7314 11.8252 31.4677 11.6831 31.1804 11.624C30.8932 11.5649 30.5949 11.5913 30.3224 11.7Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1361_5278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7 19.9707) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendButton);
export default __webpack_public_path__ + "static/media/sendButton.75ba30a2cae4420baacf0280f1bc5a8e.svg";
export { ForwardRef as ReactComponent };